<template>
    <b-form-row>
        <b-modal @hidden="handleClean" v-model="showModal" size="xl" button-size="sm" ref="finder" hide-footer
            :id="this.id" :title="prefix + title">
            <ConsultarRequisicoes :ata="ata" :prefix="prefix" @selectItem="consultarFornecedorSelect" />
        </b-modal>

        <lg-form-input-finder v-if="!isModal" :value="computedValue" fieldDescription="numeroProcesso" :label="label"
            invalidFeedback=" " description="" @handleClean="handleClean" :error="error" :cols="cols"
            :disabled="disabled">
            <template #prepend>
                <b-button :disabled="disabled" @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"

export default {
    components: { LgFormInputFinder, ConsultarRequisicoes: () => import("@/modules/compra/requisicao-compra/ConsultarRequisicoes.vue") },
    props: {

        ata: {
            type: Number,
            default: null,
        },
        isModal: {
            type: Boolean,
            default: false
        },

        disabled: {
            type: Boolean,
            default: false
        },

        id: String,
        value: Object,
        cols: String,
        label: String,
        error: {
            type: Object,
            default: null,
        },
        prefix: {
            type: String,
            default: "",
        },

        title: {
            type: String,
            default: "Consultar Requisições de Compra",
        },
    },
    data() {
        return {
            showModal: this.isModal ? true : false,

            internalValue: this.value || {},
        }
    },
    watch: {
        value(newValue) {
            this.internalValue = newValue
        },
    },
    computed: {
        computedValue: {
            get() {
                return this.internalValue
            },
            set(newValue) {
                this.internalValue = newValue
            },
        },
    },
    methods: {
        show() {
            this.showModal = true;
            this.$bvModal.show(this.id)
        },
        handleClean() {
            this.showModal = false;

            this.computedValue = {}
            this.$emit("input", null)
        },
        consultarFornecedorSelect(item) {
            this.showModal = false;

            this.computedValue = item
            this.$emit("input", item)
            this.$bvModal.hide(this.id)
        },
    },
}
</script>
